export default {
    'common.more': 'More',
    'common.collapse': 'Collapse',
    'common.noEmpty': 'Can not be empty',
    'common.validator.mobile': 'Incorrect format of mobile phone number',
    'common.validator.email': 'Error in mailbox format',
    'common.validator.number': 'Please enter the correct number',
    'common.validator.password': 'Composed of numbers, letters and underscores, within {length} characters',
    'common.validator.maxLength': 'within {length} characters',
    'common.btn.search': 'Search',
    'common.btn.reset': 'Reset',
    'common.btn.refresh': 'Refresh',
    'common.btn.add': 'New',
    'common.btn.edit': 'Edit',
    'common.btn.delete': 'Delete',
    'common.btn.confirm': 'Confirm',
    'common.btn.cancel': 'Cancel',
    'common.btn.update': 'Update',
    'common.btn.yes': 'Yes',
    'common.btn.no': 'No',
    'common.btn.look': 'View',
    'common.btn.operate': 'Operation',
    'common.datePicker.startDate': 'Start date',
    'common.datePicker.endDate': 'End date',
    'common.input.placeholder': 'Please enter',
    'common.default.option': 'please select',
    'common.tip': 'Tip',
    'common.edit.message': 'Are you sure to modify?',
    'common.success': 'Success',
    'common.total.amount': 'Total Amount',
    'widget.alert.yes': 'Confirm',
    'widget.alert.no': 'Cancel',
    'nav.language': 'Language Settings',
    'nav.language.select': 'Please select the language',
    'nav.bread.home': 'Home',
    'language.zh': '简体中文',
    'language.mx': 'Mexican',
    'language.en': 'English',
    'language.vi': 'Tiếng việt nam',
    'language.id': 'Indonesian',
    'nav.version': 'Version Information',
    'version.version': 'Version umber',
    'version.pushUser': 'Publisher',
    'version.developer': 'Developer',
    'version.releaseTime': 'Release time',
    'version.content': 'Version content',
    'nav.login': 'Sign in',
    'nav.logout': 'Sign out',
    'nav.logout.tips': 'The current user will be logged out and returned to the system portal.',
    'nav.logout.confirm': 'Confirm logout current user?',
    'nav.password': 'Update Password',
    'nav.session.add': 'Add account',
    'nav.password.old': 'Old Password',
    'nav.password.new': 'New Password',
    'nav.password.newPasswordConfirm': 'Confirm the new password',
    'nav.password.newPasswordConfirm.error': 'Inconsistent input password twice',
    'nav.historyback': 'Back',
    'nav.brand.text': 'Fund Management',
    'nav.account.title': 'Account Management',
    'nav.account.item.delete': 'Are you sure you want to delete the account?',
    'nav.account.item.confirm.state': 'Are you sure you want to {state} this account？',
    'nav.account.company.subTitle': 'Company account',
    'nav.account.company.searchForm.state': 'state',
    'nav.account.company.searchForm.stateValue.enable': 'Enable',
    'nav.account.company.searchForm.stateValue.disable': 'Disable',
    'nav.account.company.tableColumn.accountId': 'Account ID',
    'nav.account.company.tableColumn.accountName': 'Account name',
    'nav.account.company.tableColumn.currency': 'Currency Type',
    'nav.account.company.tableColumn.balance': 'Account Balance',
    'nav.account.company.tableColumn.cardNumber': 'Bank Card Number',
    'nav.account.company.tableColumn.bankName': 'Bank',
    'nav.account.company.tableColumn.phone': 'Associated Phone Number',
    'nav.account.company.tableColumn.email': 'Email',
    'nav.account.company.tableColumn.createTime': 'Account Activation Time',
    'nav.account.company.tableColumn.updateTime': 'Update Time',
    'nav.account.company.tableColumn.state': 'State',
    'nav.account.company.tableColumn.operation': 'Operation',
    'nav.account.company.columnBtn.recharge': 'Recharge',
    'nav.account.company.formData.addTitle': 'Add Company Account',
    'nav.account.company.formData.editTitle': 'Edit Company Account',
    'nav.account.company.formData.accountName': 'Account name',
    'nav.account.company.formData.currency': 'Currency Type',
    'nav.account.company.formData.balance': 'Account Balance',
    'nav.account.company.formData.cardNumber': 'Bank Card Number',
    'nav.account.company.formData.bankName': 'Bank',
    'nav.account.company.formData.phone': 'Associated Phone Number',
    'nav.account.company.formData.email': 'Email',
    'nav.account.company.formData.state': 'State',
    'nav.account.company.formData.error.accountName.required': 'AccountName is required',
    'nav.account.company.formData.error.currency.required': 'Currency is required',
    'nav.account.company.formData.recharge.title': 'Recharge Amount',
    'nav.account.company.formData.recharge.balance': 'Account Balance',
    'nav.account.company.formData.recharge.amount': 'Recharge Amount',
    'nav.account.company.formData.recharge.amount.required': 'The recharge amount cannot be empty',
    'nav.account.personal.subTitle': 'Personal account',
    'nav.account.blacklist.subTitle': 'Blacklist management',
    'nav.account.blacklist.pushItem.title': 'Blacklist the following information',
    'nav.account.blacklist.TriggerConditions.title': 'Triggering conditions',
    'nav.account.blacklist.TriggerConditions.overdueDays.title': 'Overdue days >= ',
    'nav.subjectMatter.title': 'Loan Management',
    'nav.subjectMatter.repayment.detail': 'Repayment detail',
    'nav.subjectMatter.credit': 'Disburse Management',
    'nav.subjectMatter.credit.receipt': 'Loan receipt',
    'nav.subjectMatter.credit.check': 'Loan audit',
    'nav.subjectMatter.loan': 'Loan project',
    'nav.subjectMatter.loan.detail': 'Repayment details',
    'nav.subjectMatter.repayment': 'Repayment management',
    'nav.subjectMatter.repayment.unpaid': 'Repayment details',
    'nav.subjectMatter.repayment.repaid': 'Repaid',
    'nav.subjectMatter.repayment.result': 'Repayment result',
    'nav.subjectMatter.repayment.penalty': 'Penalty record',
    'nav.subjectMatter.cashDetail': 'Fund details',
    'nav.subjectMatter.cashDetail.table.clumn.customerId': 'Customer identification',
    'nav.subjectMatter.cashDetail.table.clumn.cameraId': 'Entry identification',
    'nav.subjectMatter.cashDetail.table.clumn.amount': 'Amount change',
    'nav.subjectMatter.cashDetail.table.clumn.currency': 'Currency',
    'nav.subjectMatter.cashDetail.table.clumn.payNo': 'serial number',
    'nav.subjectMatter.cashDetail.table.clumn.fundAction': 'Capital action',
    'nav.subjectMatter.cashDetail.table.clumn.fundType': 'Type of funds',
    'nav.subjectMatter.cashDetail.table.clumn.debit': 'Add-Subtract',
    'nav.subjectMatter.cashDetail.table.clumn.remark': 'Remarks',
    'nav.subjectMatter.cashDetail.table.clumn.createTime': 'Create Time',
    'nav.subjectMatter.cashDetail.table.clumn.updateTime': 'Update Time',
    'cash.searchForm.cameraId': 'Order Number',
    'cash.searchForm.accountId': 'Account ID',
    'cash.searchForm.fundType': 'Type of funds',
    'cash.searchForm.debit': 'Change type',
    'cash.tableData.payNo': 'Serial number',
    'cash.tableData.lid': 'Account number',
    'cash.tableData.cameraId': 'Order Number',
    'cash.tableData.id': 'Account ID',
    'cash.tableData.debit': 'Change type',
    'cash.tableData.debit.add': 'Add',
    'cash.tableData.debit.reduce': 'Subtract',
    'cash.tableData.currency': 'Currency',
    'cash.tableData.amount': 'Amount change',
    'cash.tableData.fundType': 'Type of funds',
    'cash.tableData.fundType.tenant': 'Tenant',
    'cash.tableData.fundType.personal': 'Personal',
    'cash.tableData.fundType.cash': 'Cash',
    'cash.tableData.remark': 'Description',
    'cash.tableData.remark.income': 'Ingresos:',
    'cash.tableData.remark.expenditure': 'Gastos:',
    'cash.tableData.createTime': 'Create Time',
    'repayment.unpaid.searchForm.cameraId': 'Order Number',
    'repayment.unpaid.searchForm.shouldTimeDateValue': 'Time to Repay',
    'repayment.unpaid.searchForm.finishTimeDateValue': 'Settlement time',
    'repayment.unpaid.searchForm.operateTimeDateValue': 'Operate time',
    'repayment.unpaid.searchForm.payState': 'Status',
    'repayment.unpaid.searchForm.doubleLoan': 'Whether to resume loan customers',
    'repayment.unpaid.searchForm.personalOperate': 'Personal operation',
    'repayment.unpaid.operation': 'Loan operation',
    'repayment.unpaid.operation.manual': 'Manual write-off',
    'repayment.unpaid.operation.partial': 'Partial repayment',
    'repayment.unpaid.operation.substract': 'Repayment reduction',
    'repayment.unpaid.operation.settlement': 'Normal settlement',
    'repayment.unpaid.operation.extends': 'Roll over',
    'repayment.unpaid.view': 'View',
    'repayment.unpaid.view.detail': 'View repayment details',
    'repayment.unpaid.view.result': 'View payment results',
    'repayment.unpaid.tableData.cameraId': 'Order Number',
    'repayment.unpaid.tableData.productName': 'Product Name',
    'repayment.unpaid.tableData.pauseStatus': 'Suspend Collection',
    'repayment.unpaid.tableData.noPauseStatus': 'Collection Not Suspended',
    'repayment.unpaid.tableData.pauseRemark': 'Remark',
    'repayment.unpaid.tableData.dialog.title.pasuse': 'Suspend Bill Collection',
    'repayment.unpaid.tableData.dialog.title.resume': 'Resume Bill Collection',
    'repayment.unpaid.tableData.dialog.hint.pause': 'Please enter suspension note',
    'repayment.unpaid.tableData.dialog.hint.resume': 'Please enter resumption note',
    'repayment.unpaid.tableData.dialog.btn.cancel': 'Cancel',
    'repayment.unpaid.tableData.dialog.btn.pause': 'Suspend',
    'repayment.unpaid.tableData.dialog.btn.resume': 'Resume',
    'repayment.unpaid.tableData.customerName': 'Name',
    'repayment.unpaid.tableData.indexs': 'Period',
    'repayment.unpaid.tableData.shouldCapital': 'Principal repayment',
    'repayment.unpaid.tableData.factCapital': 'Repayment of principal',
    'repayment.unpaid.tableData.shouldInterest': 'Interest payable',
    'repayment.unpaid.tableData.factInterest': 'Real interest',
    'repayment.unpaid.tableData.shouldFine': 'Penalty interest',
    'repayment.unpaid.tableData.factFine': 'Repayment of Penalty interest',
    'repayment.unpaid.tableData.shouldOtherTotalFee': 'Service fee',
    'repayment.unpaid.tableData.factOtherTotalFee': 'Actual service fee',
    'repayment.unpaid.tableData.shouldOverdueFee': 'Liquidated damages payable',
    'repayment.unpaid.tableData.factOverdueFee': 'Payment of liquidated damage',
    'repayment.unpaid.tableData.subtractAmount': 'The total amount of credits',
    'repayment.unpaid.tableData.shouldTime': 'Return time',
    'repayment.unpaid.tableData.finishTime': 'Settlement time',
    'repayment.unpaid.tableData.isExtends': 'Extended Status',
    'repayment.unpaid.tableData.doubleLoan': 'Whether to resume loan customers',
    'repayment.unpaid.tableData.updateTime': 'Operate time',
    'repayment.unpaid.tableData.updateUser': 'Operate user',
    'repayment.unpaid.specialviet.form.title': 'Repayment',
    'repayment.unpaid.specialviet.form.totalAmount': 'Total due',
    'repayment.unpaid.specialviet.form.paidAmount': 'Amount of this repayment',
    'repayment.unpaid.specialviet.form.capitalAmount': 'Repayment principal',
    'repayment.unpaid.specialviet.form.interestAmount': 'Interest on this repayment',
    'repayment.unpaid.specialviet.form.penaltyAmount': 'Penalty interest for this repayment',
    'repayment.unpaid.specialviet.form.unpaidAmount': 'Remaining amount',
    'repayment.unpaid.specialviet.form.factTime.required': 'Actual repayment time cannot be empty',
    'repayment.unpaid.specialviet.form.timestatus.label': 'Arrival time＞The actual repayment time of the customer, Extra penalty required',
    'repayment.unpaid.manualDialog.title': 'Manual write-off operation',
    'repayment.unpaid.manualDialog.partPaymentData.unpaidAmount': 'Total Unpaid',
    'repayment.unpaid.manualDialog.partPaymentData.capitalAmount': 'Unpaid Principal',
    'repayment.unpaid.manualDialog.partPaymentData.interestAmount': 'Remaining Unpaid Interest',
    'repayment.unpaid.manualDialog.partPaymentData.paidAmount': 'Amount of repayment',
    'repayment.unpaid.manualDialog.partPaymentData.writeOffAmount': 'Amount of write-off',
    'repayment.unpaid.manualDialog.manualRules.paidAmount.required': 'The amount of this repayment can not be empty',
    'repayment.unpaid.manualDialog.onManualPaidSubmit.success': 'Successful write-off',
    'repayment.unpaid.manualDialog.onPartialPaidSubmit.success': 'Successful repayment',
    'repayment.unpaid.extendsDialog.onExtendsPaidSubmit.success': 'Successful extension',
    'repayment.unpaid.partialDialog.title': 'Partial repayment operation',
    'repayment.unpaid.partialDialog.htitle1': 'Current outstanding amount',
    'repayment.unpaid.partialDialog.htitle2': 'Repayment Trial Calculation',
    'repayment.unpaid.partialDialog.htitle3': 'Actual repayment time',
    'repayment.unpaid.partialDialog.unpaidData.paidAmount': 'The total has been returned',
    'repayment.unpaid.partialDialog.unpaidData.unpaidAmount': 'Not yet added up',
    'repayment.unpaid.partialDialog.unpaidData.capitalAmount': 'Unrepaid principal',
    'repayment.unpaid.partialDialog.unpaidData.interestAmount': 'Unpaid interest',
    'repayment.unpaid.partialDialog.unpaidData.penaltyAmount': 'No penalty interest',
    'repayment.unpaid.partialDialog.unpaidData.feesAmount': 'Unpaid service fee',
    'repayment.unpaid.partialDialog.calculateData.inputAmount': 'Amount of repayment',
    'repayment.unpaid.partialDialog.calculateData.trialCalculation': 'trial',
    'repayment.unpaid.partialDialog.calculateData.unpaidAmount': 'Total trial return',
    'repayment.unpaid.partialDialog.calculateData.capitalAmount': 'Trial repayment of principal',
    'repayment.unpaid.partialDialog.calculateData.interestAmount': 'Trial Interest Payment',
    'repayment.unpaid.partialDialog.calculateData.penaltyAmount': 'Trial repayment of interest',
    'repayment.unpaid.partialDialog.calculateData.feesAmount': 'Trial Return Service Fee',
    'repayment.unpaid.partialDialog.calcPartRepaymentHandler.notNumber': 'Input is not a number',
    'repayment.unpaid.partialDialog.calcPartRepaymentHandler.validNumber': 'Please enter the correct number',
    'repayment.unpaid.partialDialog.onPartailPaidSubmit.confirm': 'The amount of this repayment is {inputAmount}, Do you want to continue?',
    'repayment.unpaid.substractDialog.title': 'Repayment reduction operation',
    'repayment.unpaid.substractDialog.htitle2': 'Repayment reduction trial',
    'repayment.unpaid.substractDialog.calculateData.inputAmount': 'The amount of this reduction',
    'repayment.unpaid.substractDialog.calculateData.unpaidAmount': 'Repayment reduction',
    'repayment.unpaid.substractDialog.calculateData.capitalAmount': 'Repayment of principal',
    'repayment.unpaid.substractDialog.calculateData.interestAmount': 'Repayment of interest',
    'repayment.unpaid.substractDialog.calculateData.penaltyAmount': 'Repayment penalty',
    'repayment.unpaid.substractDialog.calculateData.feesAmount': 'Repayment reduction management fee',
    'repayment.unpaid.substractDialog.onPartailPaidSubmit.confirm':
        'The amount of this reduction is {inputAmount}, Do you want to continue?',
    'repayment.unpaid.settlementDialog.title': 'Normal clearing operation',
    'repayment.unpaid.extendsDialog.title': 'Roll over',
    'repayment.unpaid.extendsDialog.htitle1': 'Renewal amount confirmation',
    'repayment.unpaid.extendsDialog.unpaidData.extendsAmount': 'Extension amount',
    'repayment.unpaid.extendsDialog.unpaidData.extendsFee': 'Unreimbursed extension management fee',
    'repayment.unpaidDetail.title.repaidDetail': 'Unpaid details',
    'repayment.unpaidDetail.title.repaidRecord': 'Total to Pay',
    'repayment.unpaidDetail.title.substractRecord': 'Repayment reduction record',
    'repayment.unpaidDetail.detailList.totalAmount': 'Amount due',
    'repayment.unpaidDetail.detailList.couponAmount': 'Coupon reduction amount',
    'repayment.unpaidDetail.detailList.paidAmount': 'Amount paid back',
    'repayment.unpaidDetail.detailList.unpaidAmount': 'Remaining total amount payabl',
    'repayment.unpaidDetail.detailList.capitalAmount': 'Residual principal',
    'repayment.unpaidDetail.detailList.interestAmount': 'Residual interest',
    'repayment.unpaidDetail.detailList.penaltyAmount': 'Residual interest',
    'repayment.unpaidDetail.detailList.feesAmount': 'Other fee',
    'repayment.unpaidDetail.recordList.id': 'Payment Flow Number',
    'repayment.unpaidDetail.recordList.factTime': 'Actual collection time',
    'repayment.unpaidDetail.recordList.factAmount': 'Actual amount of receipt',
    'repayment.unpaidDetail.recordList.factCapital': 'Principal receipt',
    'repayment.unpaidDetail.recordList.factInterest': 'Actual interest received',
    'repayment.unpaidDetail.recordList.factFine': 'Received penalty interest',
    'repayment.unpaidDetail.recordList.factFeeAmount': 'Other fee',
    'repayment.unpaidDetail.recordList.remark': 'Remark',
    'repayment.unpaidDetail.recordList.updateRemark': 'Update remark',
    'repayment.unpaidDetail.recordList.updateRemark.success': 'Success',
    'repayment.unpaidDetail.substractList.operator': 'Operator',
    'repayment.unpaidDetail.substractList.factTime': 'Repayment reduction time',
    'repayment.unpaidDetail.substractList.factAmount': 'Total amount of repayment reduction',
    'repayment.unpaidDetail.substractList.factCapital': 'Repayment of principal',
    'repayment.unpaidDetail.substractList.factInterest': 'Repayment of interest',
    'repayment.unpaidDetail.substractList.factFine': 'Repayment penalty',
    'repayment.unpaidDetail.substractList.factFeeAmount': 'Repayment of other fees',
    'repayment.unpaidDetail.substractList.remark': 'remark',
    'repayment.unpaidDetail.lastIndex': 'Last term',
    'repayment.unpaidDetail.nextIndex': 'Next term',
    'repayment.penalty.searchForm.cameraId': 'Order Number',
    'repayment.penalty.searchForm.shouldTimeDateValue': 'Date of repayment',
    'repayment.penalty.tableData.cameraId': 'Order Number',
    'repayment.penalty.tableData.productName': 'Product Name',
    'repayment.penalty.tableData.customerName': 'Name',
    'repayment.penalty.tableData.indexs': 'Period',
    'repayment.penalty.tableData.shouldFine': 'Cumulative penalty',
    'repayment.penalty.tableData.factFine': 'Repayment of Penalty interest',
    'repayment.penalty.tableData.state': 'Status',
    'repayment.penalty.tableData.shouldTime': 'Return time',
    'repayment.penalty.view': 'View',
    'repayment.penalty.operation': 'Operating',
    'repayment.doubleLoan.first': 'No',
    'repayment.doubleLoan.double': 'Yes',
    'repayment.personalOperate.self': 'Self',
    'repayment.personalOperate.all': 'All',
    'loan.searchForm.cameraId': 'Order Number',
    'loan.searchForm.cardNo': 'License number',
    'loan.searchForm.state': 'Status',
    'loan.searchForm.releaseTime': 'Loan time',
    'loan.searchForm.customerName': 'Name',
    'loan.searchForm.phone': 'Phone number',
    'loan.tableData.cameraId': 'Order Number',
    'loan.tableData.productName': 'Product Name',
    'loan.tableData.customerName': 'Name',
    'loan.tableData.contractAmount': 'Amount to be Disbursed',
    'loan.tableData.amount': 'Loan amount',
    'loan.tableData.interest': 'Total interest',
    'loan.tableData.feeAmount': 'Service fee / management fee',
    'loan.tableData.loanCycle': 'The term',
    'loan.tableData.rate': 'Interest rate',
    'loan.tableData.state': 'Status',
    'loan.tableData.loanCreateTime': 'Create time',
    'loan.tableData.createTime': 'Credit Trial and Final Review time',
    'loan.tableData.reviewTime': 'Review time',
    'loan.tableData.releaseTime': 'Loan time',
    'loan.tableData.operation': 'operating',
    'loan.tableData.cancelLoan': 'Cancel borrowing',
    'loan.tableData.view': 'View repayment detail',
    'loan.tableData.viewRepayment': 'View repayment details',
    'loan.tableData.loanState.init': 'Pending review',
    'loan.tableData.loanState.lending': 'Laid out',
    'loan.tableData.loanState.finish': 'Closed',
    'loan.tableData.loanState.writeoff': 'Write off',
    'loan.tableData.loanState.cancel': 'Cancel',
    'loan.tableData.loanState.fail': 'Loan failure',
    'loan.tableData.loanState.refuse': 'Audit rejection',
    'loan.tableData.loanState.transaction': 'In lending',
    'loan.tableData.rateType.day': 'Daily interest{rate}%',
    'loan.tableData.rateType.month': 'Monthly interest{rate}%',
    'loan.tableData.rateType.year': 'Annual interest{rate}%',
    'loan.tableData.loanCycleUnit.day': '{loanCycle}day',
    'loan.tableData.loanCycleUnit.month': '{loanCycle}Month',
    'loan.confirm.cancelLoan': 'Confirm Withdraw Loan?',
    'loan.cancelLoan.success': 'Withdraw Success',
    'loandetail.tableData.id': 'ID',
    'loandetail.tableData.productName': 'Product Name',
    'loandetail.tableData.customerName': 'Name',
    'loandetail.tableData.indexs': 'Period',
    'loandetail.tableData.shouldCapital': 'Principal repayment',
    'loandetail.tableData.factCapital': 'Repayment of principal',
    'loandetail.tableData.shouldInterest': 'Interest payable',
    'loandetail.tableData.factInterest': 'Actual interest received',
    'loandetail.tableData.shouldFine': 'Penalty interest',
    'loandetail.tableData.factFine': 'Repayment of Penalty interest',
    'loandetail.tableData.shouldOtherTotalFee': 'Service fee',
    'loandetail.tableData.factOtherTotalFee': 'Actual service fee',
    'loandetail.tableData.shouldOverdueFee': 'Liquidated damages payable',
    'loandetail.tableData.factOverdueFee': 'Payment of liquidated damage',
    'loandetail.tableData.shouldTime': 'Return time',
    'loandetail.tableData.factTime': 'Actual collection time',
    'loandetail.tableData.view': 'View',
    'credit.check.tableData.bankName': 'Bank',
    'credit.check.tableData.bankCard': 'Bank card Number',
    'credit.check.tableData.phone': 'Phone number',
    'credit.check.tableData.cardNo': 'License number',
    'credit.check.aciton.view': 'View',
    'credit.check.aciton.check': 'Review',
    'credit.check.button.reject': 'Refuse',
    'credit.check.button.approve': 'Agree',
    'credit.check.button.batchReview': 'Batch Review',
    'credit.check.dialog.remark': 'Remarks',
    'credit.check.dialog.rejected': 'Rejected',
    'credit.check.dialog.approved': 'approved',
    'repayment.state.repaid': 'Repaid',
    'repayment.state.unpaid': 'Unpaid',
    'repayment.state.normal': 'Normal repayment',
    'repayment.state.overdue': 'Overdue',
    'repayment.state.afterOverdue': 'Repayment after overdue',
    'repayment.state.partial': 'Partial repayment',
    'repayment.state.afterPartial': 'Settlement after partial repaymen',
    'repayment.state.manual': 'Manual Write Off',
    'repayment.state.cancel': 'Cancel',
    'repayment.isExtends.notExtends': 'No extensions',
    'repayment.isExtends.extending': 'extension',
    'repayment.isExtends.extends': 'extended',
    // 催收核销
    'repayment.hx.status': 'status',
    'repayment.hx.overrideType': 'override type',
    'repayment.hx.orderNumber': 'order number',
    'repayment.hx.repaymentAmount': 'Repayment Amount',
    'repayment.hx.createTime': 'Creation time',
    'repayment.hx.updateTime': 'Update time',
    'repayment.hx.createUserName': 'Creater',
    'repayment.hx.updateUserName': 'updater',
    'repayment.hx.viewCredentials': 'View credentials',
    'repayment.hx.operating': 'operating',
    'repayment.hx.manualOverride': 'Manual override',
    'repayment.hx.partialRepayment': 'Partial repayment',
    'repayment.hx.normalSettlement': 'Normal settlement',
    'repayment.hx.cancel': 'cancel',
    'repayment.tallyBillState.waitApprove': 'Pending',
    'repayment.tallyBillState.finishApprove': 'Write-off completed',
    'repayment.tallyBillState.cancelApprove': 'Cancelled',
    'repayment.tallyBillType.inbursaRepay': 'Repayment with INBURSA',
    'repayment.tallyBillType.overdueRepay': 'User repayment after long-term overdue override',
    'repayment.hx.noVoucherUpload': 'No voucher uploaded for the current document',
    'repayment.hx.stateNotSupportOperation': 'The current state does not support the operation',
    'repayment.hx.cancelSuccess': 'Cancel success',
    'repayment.hx.sureCancel': 'Are you sure to cancel',
    'repayment.hx.cancelFailed': 'Cancellation failed, please check',
    'nav.subjectMatter.repayment.hx': 'Collection verification management',
    /** 支付管理 */
    'common.isDelete': 'Delete?',
    'status.NameNoNull': 'The status cannot be empty',
    'sync.member': 'Sync Member Information',
    'typeList.filter.time': 'Create Time',
    'outcome.amount': 'amount',
    'callRecord.filter.serialId': 'Run Number',
    'serviceFee.userId': 'User ID',
    'merchant.scenario': 'Scene',
    'icon.copy': 'Copy',
    'notice.StatusNoNull': 'The notification status cannot be empty',
    'payType.name': 'Payment Type',
    'payType.NoNull': 'Payment type cannot be empty',
    'merchant.StatusNoNull': 'Tenant cannot be empty',
    'pri.NoNull': 'Sort cannot be empty',
    'batch.add': 'Batch add',
    'bank.id': 'Bank ID',
    'bank.name': 'Bank Name',
    'bank.icon': 'Icon',
    'bank.tel': 'Contact Phone',
    'bank.website': 'Official Website URL',
    'bank.promptMsg': 'Prompt Copy',
    'bank.payType': 'Payment Method',
    'bank.status': 'Status',
    'bank.disable': 'Deactivate',
    'bank.enable': 'Enable',
    'bank.addDialogTitle': 'Add bank',
    'bank.invalid': 'Invalid',
    'bank.effective': 'Valid',
    'bank.isBatchEnable': 'Is it enabled?',
    'bank.isBatchDisable': 'Do you want to disable?',
    'bank.title': 'Bank',
    'bank.config': 'Bank Configuration',
    'bank.tenant': 'Tenant',
    'bank.merchantNoNull': 'The tenant cannot be empty',
    'bank.NoNull': 'Bank be empty',
    'bank.thridName': 'Tripartite Name',
    'bank.thridBankNameNoNull': 'The three-party name cannot be empty',
    'bankCardManage.userId': 'User Id',
    'bankCardManage.userName': 'Name',
    'bankCardManage.realName': 'Full Name',
    'bankCardManage.firstName': 'Name',
    'bankCardManage.lastName': 'Last Name',
    'bankCardManage.expirationYear': 'Validity Year',
    'bankCardManage.expirationMonth': 'Validity Month',
    'bankCardManage.cvv2': 'Credit Card Security Code',
    'bankCardManage.tel': 'Mobile Number',
    'bankCardManage.IDCard': 'Document Number',
    'bankCardManage.idType': 'Document Type',
    'bankCardManage.cardNum': 'Card Number',
    'bankCardManage.oprType': 'Lending Type',
    'bankCardManage.cardType': 'Card Type',
    'bankCardManage.email': 'Mailbox',
    'bankCardManage.bankName': 'Bank Name',
    'bankCardManage.bankId': 'Bank Id',
    'bankCardManage.status': 'Status',
    'bankCardManage.createTime': 'Create Time',
    'bankCardManage.merchantId': 'Tenant Id',
    'bankCardManage.addDialogTitle': 'Add user bank card management',
    'bankCardManage.normal': 'Normal',
    'bankCardManage.enable': 'Enable',
    'bankCardManage.notenable': 'Not Enabled',
    'bankCardManage.disable': 'Freeze',
    'bankCardManage.identityType': 'ID Card',
    'bankCardManage.debitCard': 'Debit Card',
    'bankCardManage.creditCard': 'Credit Card',
    'bankCardManage.semiCreditCard': 'Quasi-credit Card',
    'bankCardManage.prepaidCard': 'Prepaid Card',
    'bankCardManage.valid': 'whether To Verify',
    'bankCardManage.notCheck': 'Unverified',
    'bankCardManage.passedCheck': 'Verify Pass',
    'bankCardManage.failededCheck': 'Verification Failed',
    'bankCardManage.checking': 'Verification',
    'bankCardManage.cardNumNoNull': 'The card number cannot be empty',
    'bankCardManage.identityNoNull': 'The certificate number cannot be empty',
    'bankCardManage.merchantIdNoNull': 'Tenant Id cannot be empty',
    'bankCardManage.bankIdNoNull': 'Bank Id cannot be empty',
    'bankCardManage.isBatchDisable': 'Is it frozen?',
    'bankCardManage.ifscCode': 'IFSCCode',
    'returnCode.channelNoNull': 'Please select channel',
    'returnCode.paymentTypeNoNull': 'Please select the payment type',
    'returnCode.name': 'Return Code',
    'returnCode.returnMsg': 'Return Information',
    'sales.failCount': 'failCount',
    'sales.note': 'Remarks',
    'sales.documentsState': 'Document Status',
    'sales.updateTime': 'Update Time',
    'sales.operation': 'Operation',
    'sales.generateScreenshot': 'Get Screenshot',
    'sales.download': 'Download',
    'sales.toast': 'Generation failed... Null values ​​exist in the data.',
    'sales.documentsNo': 'Receipt Note Number',
    'sales.realName': 'Real Name',
    'sales.bankCardNo': 'Bank Card Number',
    'repay.add': 'Add',
    'repay.reviewed': 'Reviewed',
    'repay.doing': 'Processing',
    'repay.completed': 'Completed',
    'repay.refused': 'Rejected',
    'repay.paying': 'Payment',
    'repay.pending': 'Pending',
    'repay.paymentSuccess': 'Payment Success',
    'repay.paymentFail': 'Payment Failed',
    'repay.abnormal': 'Exception',
    'statusType.submitted': 'Submit',
    'statusType.pending': 'To be determined',
    'statusType.processing': 'Processing',
    'statusType.completed': 'Complete',
    'statusType.error': 'Error',
    'bank.bankNameNoNull': 'Bank name cannot be empty',
    'bank.realNameCannot be empty': 'Full name cannot be empty',
    'bank.phoneNoNull': 'The contact number cannot be empty',
    'lending.FinancialCodeExpired': 'Financial code expired',
    'lending.HasBeenCancelled': 'Cancelled',
    'chargeback.add': 'add',
    'chargeback.deducting': 'Deduction',
    'chargeback.completeOfPart': 'Partial Completion',
    'chargeback.closed': 'Closed',
    'chargeback.allCpmplete': 'all complete',
    'chargeback.expireDate': 'expire date',
    'chargeback.exception': 'exception',
    'deduct.DocumentStatus': 'document status',
    'deduct.RepaymentCode': 'Repayment code',
    'deduct.RepaymentPeriodTime': 'Repayment period',
    'deduct.ShouldAlsoAmount': 'should be repaid',
    'deduct.RepayAmount': 'Repayment Amount',
    'deduct.ActualAmount': 'Real amount',
    'deduct.expireDate': 'expiration time',
    'deduct.createTime': 'create time',
    'deduct.realAmount': 'The actual amount',
    'deduct.purchaseCurrency': 'Currency',
    'Generate return code': 'Generate return code',
    'Repayment code': 'Repayment code',
    'Repayment trial': 'Repayment trial',
    'Try to pay back the principal': 'Try to pay back the principal',
    'Try to pay interest': 'Try to pay interest',
    'Try to pay a penalty': 'Try to pay a penalty',
    'Trial management fee': 'Trial management fee',
    'Trial total': 'Trial total',
    'Repayment channel': 'Repayment channel',
    'repayment.merge.generate': 'Generate repayment code ({count})',
    'repayment.merge.selectedPlans': 'Selected repayment plans',
    'repayment.merge.shouldTime': 'Due date',
    'repayment.merge.unpaidAmount': 'Outstanding amount',
    'repayment.merge.overdueFee': 'Trial overdue fee',
    'repayment.merge.openLink': 'Open repayment link',
    'repayment.merge.previewFailed': 'Merged repayment calculation failed',
    'repayment.merge.invalidState': 'Only unpaid, overdue, or partially paid bills can be selected',
    'repayment.merge.sameMainBillRequired': 'Only repayment plans from the same main bill can be merged',
    'channel.loanDocuments': 'Lending Documents',
    'channel.orderNo': 'Order Number',
    'channel.outcomeId': 'Lending order number',
    'channel.oanApplicationDate': 'Payment Application Date',
    'channel.loanAmount': 'Loan Amount',
    'channel.loanTime': 'Loan Time',
    'channel.pleaseEnterTheLoanTime': 'Please select the time of the loan',
    'channel.lendingDate': 'Actual Lending Date',
    'channel.lendingApplyDate': 'Lending Application Date',
    'channel.payingDate': 'Actual Repayment Time',
    'channel.name': 'Name',
    'channel.idNo': 'Document Number',
    'channel.bvn': 'BVN',
    'channel.payStatus': 'Payment Status',
    'channel.confirmTheLoan': 'Confirm The Loan',
    'channel.lendingAgain': 'Re-lending',
    'channel.cancelLending': 'Cancel The Loan',
    'channel.Invalid': 'Invalid',
    'channel.isConfirmTheLoan': 'Do you confirm the loan?',
    'channel.isConfirmTheLoanFailure': 'Do you confirm that the loan failed?',
    'channel.isLoanSuccess': 'Do you confirm that the loan was successful?',
    'channel.isConfirmLendingAgain': 'Do you want to confirm re-lending?',
    'channel.isConfirmCancelLending': 'Are you sure to cancel the loan?',
    'channel.loanSuccess': 'Lending Money',
    'channel.loanSuccessBatch': 'Batch lending success',
    'channel.manualLending': 'Manual Loan',
    'channel.systemLending': 'system Lending',
    'channel.loanFailure': 'Loss Failed',
    'channel.loanExport': 'Export',
    'channel.notPaying': 'Not Paid',
    'channel.changeOprType': 'Change Payment Type',
    'channel.isConfirmChangeOprType': 'Are you sure to change the payment type?',
    'channel.businessParam': 'Whether to resume loan customers',
    'channel.firstLoan': 'No',
    'channel.doubleLoan': 'Yes',
    'channel.channel': 'Channel',
    'channel.bankCoding': 'Bank Code',
    'channel.NoNull': 'Channel cannot be empty',
    'channel.threePartiesMerchantNumber': 'Three-party merchant number',
    'channel.merchantNoNull': 'The three-party merchant number cannot be empty',
    'channel.channelName': 'Channel Name',
    'channel.channelID': 'Channel ID',
    'channel.channelNumber': 'Channel Number',
    'channel.createTime': 'Create Time',
    'channel.theTemporaryClosureOfOpenTime': 'Temporarily Turn Off The On Time',
    'channel.theTemporaryClosureOfTheEndOfTime': 'Temporary Shutdown End Time',
    'channel.rule.channelID': 'Composed of numbers, letters and underscores, within 20 characters',
    'channel.rule.channelName': 'Rule name within 20 characters',
    'channel.rule.channelNumber': 'Within 100 characters',
    'routing.sorting': 'Sorting',
    'routing.weight': 'Weight',
    'routing.weightRequired': 'Weight cannot be empty',
    'routing.weightInvalid': 'Weight must be a non-negative integer',
    'routing.singleLimit': 'Single Limit',
    'routing.singleMinimumLimit': 'Single Minimum Limit',
    'routing.dailyLimit': 'Single Day Limit',
    'routing.monthlyAllowance': 'Single Month Limit',
    'routing.theTemporaryClosureOfInformation': 'Temporary Shutdown Information',
    'routing.basicInformation': 'Basic Information',
    'routing.lendingDetail': 'Loan payment details',
    'routing.repaymentDetail': 'Repayment payment details',
    'routing.pauseCollection': 'Suspend Collection',
    'routing.resumeCollection': 'Resume Collection',
    'payment.sourceMerchantId': 'Source Merchant ID',
    'payment.targetMerchantId': 'Target Merchant ID',
    'base.three.part.config': 'Tripartite configuration',
    'base.three.part.config.type': 'Payment types',
    'base.three.part.config.channel': 'Channel',
    'base.three.part.config.add': 'Bulk addition',
    'base.three.part.config.delete': 'Delete',
    'base.three.part.config.modify': 'Modify',
    'base.three.part.config.id': 'Main id',
    'base.three.part.config.channel.id': 'Channel id',
    'base.three.part.config.channel.name': 'Channel name',
    'base.three.part.config.payment.type': 'Payment type',
    'base.three.part.config.payment.desc': 'Payment type description',
    'base.three.part.config.key': 'Key',
    'base.three.part.config.value': 'Value',
    'base.three.part.rules.key': 'Please enter the key',
    'nav.bank.bankcard.title': 'User Bank Card Management',
    'nav.bank.title': 'Bank Card Management',
    'nav.receipt.title': 'Document management',
    'nav.receipt.lending.title': 'Loan receipt',
    'nav.receipt.lending.detail.title': 'Loan details',
    'nav.receipt.repayment.title': 'Repayment receipt',
    'nav.receipt.repayment.detail.title': 'Repayment details',
    'nav.routing.title': 'Routing configuration',
    'nav.routing.lending.title': 'Loan routing',
    'nav.routing.repayment.title': 'Repayment routing',
    'nav.channel.title': 'Channel configuration',
    'nav.channel.compare.title': 'Channels and banks',
    'nav.channel.threepart.title': 'Channel parameters',
    'nav.channel.channel.title': 'Channel list',
    'nav.channel.merchant.title': 'Tenant configuration',
    'nav.channel.bank.title': 'Tenants and banks',
    'nav.documents.title': 'Bank details',
    'documents.user': 'Name',
    'documents.transDate': 'Effective Date',
    'documents.importDate': 'New import date',
    'documents.bindDate': 'Settlement date',
    'documents.borrower': 'Name',
    'documents.phone': 'Phone',
    'documents.status': 'Status',
    'documents.operator': 'operator',
    'documents.number': 'Trans Reference',
    'documents.amount': 'Amount',
    'documents.createDate': 'Trans Date',
    'documents.ShouldAlsoAmount': 'Total repayment',
    'documents.releaseTime': 'Disburse time',
    'documents.shouldTime': 'Repayment date',
    'documents.download': 'Download template',
    'documents.import': 'Mismatch',
    'documents.import.result': 'Mismatch results',
    'documents.import.drag': 'Drag the Excel file here, or ',
    'documents.import.click': 'click upload',
    'documents.import.tip.maxsize': 'Only xlsx files can be uploaded, and no more than',
    'documents.import.type.excel': 'Not an Excel file',
    'documents.import.size.excel': 'File size must be less than {size}M',
    'documents.import.exceed': 'Exceed',
    'documents.bind': 'Confirm',
    'documents.unbound': 'Review',
    'documents.amount.all': 'All Amount'
}
